import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { MatSpinnerOverlayComponent } from '../../components/mat-spinner-overlay/mat-spinner-overlay.component';
import { RedeEspecialAcordoDialogBase } from '../rede-especial-dialog-base';
import {
  AcordoRedeEspecialViewModel,
  PayloadCancelarAcordo,
} from '../rede-especial.interface';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-cancelar-acordo-dialog',
  templateUrl: './cancelar-acordo-dialog.component.html',
  styleUrls: ['./cancelar-acordo-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSpinnerOverlayComponent,
  ],
})
export class CancelarAcordoDialogComponent extends RedeEspecialAcordoDialogBase<CancelarAcordoDialogComponent> {
  formCancelamento: FormGroup;

  constructor(
    private fb: FormBuilder,
    public override dialogRef: MatDialogRef<CancelarAcordoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    override acordosSelecionados: AcordoRedeEspecialViewModel[],
    service: RedeEspecialService,
    snackBar: SnackBarService,
  ) {
    super(dialogRef, acordosSelecionados ?? [], service, snackBar);
    this.formCancelamento = this.fb.group({
      motivo: ['', Validators.required],
    });
  }

  onConfirmar(): void {
    if (!this.acordosSelecionados?.length) {
      this.snackBar.flashMessage(
        'Nenhum acordo selecionado.',
        ['snackbar-error'],
        'Fechar',
        2,
      );
      return;
    }
    this.loading = true;
    const motivo = this.formCancelamento.get('motivo')?.value ?? '';
    const listaAcordos: PayloadCancelarAcordo[] = this.acordosSelecionados.map(
      (acordo) => ({
        codAcordo: acordo.codAcordo,
        codAep: acordo.codAep,
        codAdc: acordo.codAdc,
        codSituacao: acordo.codSituacao,
        dscUsuario: this.usuarioLogin,
        motivoCancelamento: motivo,
      }),
    );
    this.service.cancelarAcordo(listaAcordos).subscribe({
      next: () => {
        this.snackBar.flashMessage(
          'Acordo(s) cancelado(s) com sucesso!',
          ['snackbar-success'],
          'Fechar',
          2,
        );
        this.dialogRef.close({ confirmado: true });
      },
      error: () => {
        this.snackBar.flashMessage(
          'Erro ao cancelar acordos!',
          ['snackbar-error'],
          'Fechar',
          2,
        );
        this.dialogRef.close({ confirmado: false });
      },
      complete: () => (this.loading = false),
    });
  }
}
